<template>
  <transition name="fade">
    <div class="fixed top-0 h-screen w-screen top-0 bottom-0 bg-gray-500/50 z-10" v-if="show">
      <div class="bg-white rounded-lg w-4/5 mt-[8%]  mx-auto p-4" @click.stop>
        <h1 class="text-center">{{ title }}</h1>
        <hr class="border-brand/50 my-4">
        <slot></slot>
      </div>
  </div>
  </transition>
</template>

<script>
export default {
  name: "VModal",
  props: ['show', 'title']
}
</script>

<style scoped>

</style>